import { call, put, select, takeLatest } from 'redux-saga/effects'
import {  getTransaction } from '../../firebase-services/db-services';
import { getPartiesLedgerSuccess, selectLedgerFilter } from '../slices/partyState';
function* async_getPartyLedgerFetch() {
    const filter = yield select(selectLedgerFilter)
    
    const transaction = yield call(()=>getTransaction(filter));
    const formattedTransaction = yield transaction.docs;
    //console.log({filter,transaction})
    const transactionData = formattedTransaction.map(doc =>{
        return {...doc.data(),docid:doc.id}
    } )
    //console.log({transactionData})
    yield put(getPartiesLedgerSuccess(transactionData))
        
}
function* ledgerSaga() {
    yield takeLatest('parties/getPartiesLedgerFetch', async_getPartyLedgerFetch);
}
export default ledgerSaga;